/* eslint jsx-a11y/label-has-associated-control:0 jsx-a11y/label-has-for:0 */
import React from 'react';
import PropTypes from 'prop-types';

import TranslationProvider from '../../../providers/TranslationProvider';

import './FavoritesBanner.scss';
import CheckboxSwitch from '../../Checkbox/Switch';

/* eslint-disable max-len */
const marketingOptIn = 'Sign up for Resy marketing emails to receive curated recommendations and insider tips on top restaurants in your area. You agree to the use of your data as described in our <a href="/privacy" target="_blank">Privacy Policy</a>. You may opt out of receiving marketing emails at any time.';

const FavoritesBanner = ({ toggleIsMarketable, isMarketable }) => (
  <div className="FavoritesBanner">
    <TranslationProvider translationKey="favorites_optin_header">
      <h2>Sign Up for Resy Email</h2>
    </TranslationProvider>
    <TranslationProvider translationKey="favorites_optin_title">
      <div className="FavoritesBanner__title">Monthly Hit Lists, Straight to Your Inbox</div>
    </TranslationProvider>
    <div className="FavoritesBanner__content">
      <TranslationProvider translationKey="favorites_optin_content">
        <p>{marketingOptIn}</p>
      </TranslationProvider>
    </div>
    <div className="d-inline-flex">
      <CheckboxSwitch
        on={isMarketable}
        onClick={toggleIsMarketable}
        name="favoritesOptIn"
      />
      <TranslationProvider translationKey="favorites_optin_label">
        <label className="FavoritesBanner__optin-label" htmlFor="marketing_opt_in">Sign Up for Email</label>
      </TranslationProvider>
    </div>
  </div>
);

FavoritesBanner.propTypes = {
  toggleIsMarketable: PropTypes.func.isRequired,
  isMarketable: PropTypes.bool.isRequired,
};

FavoritesBanner.displayName = 'FavoritesBanner';

export default FavoritesBanner;
